import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { GlobalSearchComponent } from './global-search.component';
import { SharedModule }          from '../shared/shared.module';

@NgModule({
  declarations: [
    GlobalSearchComponent
  ],
  entryComponents: [
    GlobalSearchComponent
  ],
  exports: [
    GlobalSearchComponent
  ],
  imports: [
    SharedModule
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class GlobalSearchModule {}
